import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  getContactoPreferenciasById,
  getContactosByFilterSimple,
} from "api/Contacto.service"
import { FORMA_PAGO } from "api/Types/FormaPago"
import Spinner from "common/components/Spinner/Spinner"
import useContactos from "features/Contactos/hooks/useContactos"
import { getContactoFacturaRecurrente } from "features/Contactos/redux/slices/contactoSlice"
import {
  getLibradoEmailsOptions,
  newDocumentoSelector,
} from "features/Crear/redux/selectors/newDocumentoSelectors"
import { newDocumentoSettingsSelector } from "features/Crear/redux/selectors/newDocumentoSettingsSelectors"
import {
  changeLibradoEmail,
  clearLibrado,
  deleteFormaPagoIban,
  setFechaVencimiento,
  setLibrado,
} from "features/Crear/redux/slices/newDocumentoSlice"
import { formatDireccion } from "features/Crear/utils/formatDireccion"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { Dropdown } from "primereact/dropdown"
import { Tooltip } from "primereact/tooltip"
import { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { ButtonAction } from "../ConceptosTable"
import LibradoSearchForm from "./LibradoSearchForm"

const LibradoCard = ({
  canEditLibradoLibrador,
  setObservacionCesion,
  observacionCesion,
  libradoRecurrente,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [showEmails, setShowEmails] = useState(false)
  const { librado, isLibrado, fechaEmision, convertNextDoc, formaPago } =
    useSelector(newDocumentoSelector)
  const { colorSelected } = useSelector(newDocumentoSettingsSelector)
  const { editContacto, handleSelectContacto, contacto, fetchingContacto } =
    useContactos(setLibrado)
  const emailsOptions = useSelector(getLibradoEmailsOptions)
  const dropdrownRef = useRef()

  const deleteLibrado = () => {
    setObservacionCesion(false)
    setShowEmails(false)
    // @ts-expect-error TS(2345): Argument of type...
    dispatch(clearLibrado(null))
    formaPago === FORMA_PAGO.PAGO_DOMICILIADO && dispatch(deleteFormaPagoIban())
  }

  const editLibrado = () => {
    const paginationNeeded = true
    const isCliente = true
    editContacto(
      librado.id,
      paginationNeeded,
      Boolean(libradoRecurrente),
      librado,
      isCliente
    )
  }

  const selectLibradoEmail = (e: $TSMigrationFixMe) => {
    dispatch(changeLibradoEmail(e.value))
    setShowEmails(false)
  }

  const hasEmails = librado?.emails?.length > 1
  const ableToEdit = canEditLibradoLibrador && librado && !isLibrado

  useEffect(() => {
    if (libradoRecurrente?.libradorId) {
      dispatch(getContactoFacturaRecurrente(libradoRecurrente))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [libradoRecurrente?.libradorId])

  // @ts-expect-error TS(7030): Not all code paths return a value.
  const changeFechaVencimiento = async (contactoId: $TSMigrationFixMe) => {
    if (!contactoId) {
      return dispatch(setFechaVencimiento(fechaEmision))
    }
    const data = await getContactosByFilterSimple({
      queryParams: { Cif: librado?.nif },
    })
    const { diaDePago } = await getContactoPreferenciasById(
      data.items?.[0]?.id ?? contactoId
    )
    const newDate = new Date(fechaEmision)
    // @ts-expect-error TS(2533): Object is possibly 'null' or 'undefined'.
    newDate.setDate(newDate.getDate() + diaDePago)
    // @ts-expect-error TS(2345): Argument of type...
    dispatch(setFechaVencimiento(newDate))
  }

  useEffect(() => {
    !isLibrado && convertNextDoc && changeFechaVencimiento(librado?.id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [librado])

  return (
    <div className='border-0 card'>
      <div
        style={{ backgroundColor: colorSelected }}
        className={`card-header header-blue d-flex align-items-center justify-content-between ${
          !librado && "opacity-5"
        }`}
      >
        <p className='mb-0'>{t("crear.facturaRec.clientDataHeader")}</p>
        {ableToEdit ? (
          <span className='d-flex align-items-center'>
            <ButtonAction
              iconName='pen'
              onClick={editLibrado}
              className='mr-1 tx-white'
              classNameIcon='icon-size-md'
            />
            <ButtonAction
              iconName='xmark'
              onClick={deleteLibrado}
              className='mr-1 tx-white'
              classNameIcon='icon-size-md'
            />
          </span>
        ) : null}
      </div>
      {fetchingContacto ? (
        <Spinner />
      ) : (
        <div className='p-0 text-left card-body'>
          <>
            {librado ? (
              <div className='container p-3'>
                <p className='h5 font-weight-500'>{librado?.razonSocial}</p>
                <p className='mb-2'>{librado?.nif}</p>
                <p className='mb-2'>{formatDireccion(librado)}</p>
                <div className='mb-2'>
                  <Dropdown
                    autoFocus
                    showOnFocus
                    value={librado?.email}
                    onChange={selectLibradoEmail}
                    options={emailsOptions}
                    // @ts-expect-error TS(2769): No overload matches this call.
                    ref={dropdrownRef}
                    style={{ display: showEmails ? "" : "none" }}
                  />
                  {!showEmails && (
                    <span
                      className={`emailLibradoChange ${
                        hasEmails ? "cursor-pointer" : ""
                      }`}
                      onClick={() => {
                        setShowEmails(hasEmails)
                        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
                        dropdrownRef.current.state.overlayVisible = true
                      }}
                    >
                      {librado.email || ""}
                      {hasEmails ? (
                        <>
                          <Tooltip
                            target='.emailLibradoChange'
                            // @ts-expect-error TS(2769): No overload matches this call.
                            content={t("crear.facturaRec.changeMailLabel")}
                          />
                          <FontAwesomeIcon icon={["fal", "angle-down"]} />
                        </>
                      ) : null}
                    </span>
                  )}
                </div>
                <p className='mb-2'>
                  {librado?.telefono || libradoRecurrente?.telefono}
                </p>
              </div>
            ) : (
              <LibradoSearchForm
                libradoDate={librado}
                observacionCesion={observacionCesion}
                setObservacionCesion={setObservacionCesion}
                handleSelectCliente={handleSelectContacto}
                cliente={contacto}
              />
            )}
          </>
        </div>
      )}
    </div>
  )
}

export default LibradoCard
